import ProfilePicture from '../images/profile-picture.jpg';

const personalInfos = {
    email:"charpentierav@gmail.com",
    phone:"(+33)7 81 28 40 39",
    place:"45140, Saint-Jean-de-la-Ruelle",
    profilePicture: ProfilePicture,
}

export default personalInfos;